<header class="adm-hero">
  <div class="adm-hero__inner">
    @if (showBack()) {
      <button type="button" class="adm-hero__back" (click)="back.emit()">
        <i class="bx bx-arrow-back" aria-hidden="true"></i>
        <span>{{ backLabel() ?? 'Back' }}</span>
      </button>
    }
    <div class="adm-hero__row">
      <div class="adm-hero__identity">
        @if (avatarUrl(); as url) {
          <img class="adm-hero__avatar" [src]="url" alt="" />
        } @else {
          <span class="adm-hero__avatar adm-hero__avatar--initials" aria-hidden="true">{{ displayInitials() }}</span>
        }
        <div class="adm-hero__titles">
          @if (eyebrow(); as kicker) {
            <span class="adm-hero__eyebrow">{{ kicker }}</span>
          }
          <h1 class="adm-hero__name">{{ title() }}</h1>
          @if (subtitle(); as line) {
            <p class="adm-hero__subtitle">
              @if (subtitleIcon(); as icon) {
                <i class="bx {{ icon }}" aria-hidden="true"></i>
              }
              {{ line }}
            </p>
          }
        </div>
      </div>
      <div class="adm-hero__actions">
        <ng-content select="[hero-actions]" />
      </div>
    </div>
  </div>
</header>
